export default __webpack_public_path__ + "static/media/graphic-23.a2d0f5a9.png";